export type ChangeCategory = "feature" | "improvement" | "fix" | "misc";

export interface ChangeSection {
  title: string;
  category: ChangeCategory;
  items: string[];
}

export interface ReleaseEntry {
  version: string;
  date: string;
  title: string;
  sections: ChangeSection[];
}

export interface ReleaseIndex {
  version: string;
  date: string;
  title: string;
}

const versionModules = import.meta.glob<ReleaseEntry>("@changelog/v*.json", {
  eager: true,
  import: "default",
});

import indexData from "@changelog/index.json";

export const releaseIndex: ReleaseIndex[] = indexData;

const releaseCache = new Map<string, ReleaseEntry>();

for (const [, data] of Object.entries(versionModules)) {
  releaseCache.set(data.version, data);
}

export function getRelease(version: string): ReleaseEntry | undefined {
  return releaseCache.get(version);
}

export function getAllReleases(): ReleaseEntry[] {
  return releaseIndex
    .map((entry) => releaseCache.get(entry.version))
    .filter((r): r is ReleaseEntry => r !== undefined);
}
